/* eslint-disable import/no-unresolved */

import { createVueApp } from '@vuejs/entry';
import MysavickiCalculatorApp from '@vuejs/apps/MysavickiCalculatorApp.vue';

const initNav = () => {
    const nav = document.getElementById('ms-nav');
    if (!nav) return;
    const onScroll = () => {
        nav.classList.toggle('scrolled', window.scrollY > 60);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
};

const initFaq = () => {
    const list = document.querySelector('[data-faq]');
    if (!list) return;

    list.querySelectorAll('.ms-faq-question').forEach((btn) => {
        btn.addEventListener('click', () => {
            const item = btn.closest('.ms-faq-item');
            if (!item) return;
            const wasOpen = item.classList.contains('open');

            list.querySelectorAll('.ms-faq-item').forEach((i) => {
                i.classList.remove('open');
                const q = i.querySelector('.ms-faq-question');
                if (q) q.setAttribute('aria-expanded', 'false');
            });

            if (!wasOpen) {
                item.classList.add('open');
                btn.setAttribute('aria-expanded', 'true');
            }
        });
    });
};

const initReveal = () => {
    const targets = document.querySelectorAll('.mysavicki .reveal');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('visible'));
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const parent = entry.target.parentElement;
                const siblings = parent
                    ? parent.querySelectorAll(':scope > .reveal')
                    : [entry.target];
                const index = Array.from(siblings).indexOf(entry.target);
                setTimeout(() => entry.target.classList.add('visible'), index * 80);
                observer.unobserve(entry.target);
            });
        },
        { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach((el) => observer.observe(el));
};

const mountCalculator = () => {
    const el = document.getElementById('mysavicki-calculator-app');
    if (!el) return;
    const app = createVueApp(MysavickiCalculatorApp);
    app.mount(el);
};

document.addEventListener('DOMContentLoaded', () => {
    initNav();
    initFaq();
    initReveal();
    mountCalculator();
});
